import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

export default function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handler = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div style={{ display:'flex', minHeight:'100vh' }}>
      <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} isMobile={isMobile}/>
      <div style={{
        flex:1,
        marginLeft: isMobile ? 0 : '256px',
        display:'flex', flexDirection:'column', minHeight:'100vh',
        transition:'margin-left 0.25s ease',
      }}>
        <TopBar onMenuToggle={() => setSidebarOpen(p => !p)} isMobile={isMobile}/>
        <main style={{
          flex:1,
          padding: isMobile ? '16px' : '32px',
          maxWidth:'1200px', width:'100%',
          animation:'fadeUp 0.18s ease',
        }}>
          {children}
        </main>
      </div>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,400&display=swap');
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'DM Sans','Helvetica Neue',sans-serif; background:#0e0e0d; color:#f0ede8; -webkit-font-smoothing:antialiased; overflow-x:hidden; }
        @keyframes spin { to { transform:rotate(360deg); } }
        @keyframes fadeUp { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } }
        ::-webkit-scrollbar { width:5px; height:5px; }
        ::-webkit-scrollbar-track { background:transparent; }
        ::-webkit-scrollbar-thumb { background:#2a2927; border-radius:3px; }
        input:focus, textarea:focus, select:focus { outline:none !important; border-color:#c49a3c !important; box-shadow:0 0 0 3px rgba(196,154,60,0.15) !important; }
        input::placeholder, textarea::placeholder { color:#4a4845; }
        select option { background:#1c1b19; color:#f0ede8; }
        table { width:100%; border-collapse:collapse; }
        th { background:#1c1b19; color:#6b6966; font-weight:600; font-size:11px; text-transform:uppercase; letter-spacing:0.8px; padding:10px 16px; text-align:left; border-bottom:1px solid #2a2927; }
        td { padding:12px 16px; font-size:14px; color:#a8a49e; border-bottom:1px solid #1c1b19; }
        tr:hover td { background:#1a1918; }
        input[type="range"] { -webkit-appearance:none; appearance:none; height:4px; background:#2a2927; border-radius:2px; outline:none; cursor:pointer; border:none !important; box-shadow:none !important; }
        input[type="range"]::-webkit-slider-thumb { -webkit-appearance:none; appearance:none; width:14px; height:14px; border-radius:50%; background:#c49a3c; cursor:pointer; border:2px solid #0e0e0d; }
        input[type="date"]::-webkit-calendar-picker-indicator { filter:invert(0.6); cursor:pointer; }
        @media (max-width:768px) { table { display:block; overflow-x:auto; white-space:nowrap; } }
      `}</style>
    </div>
  );
}
